var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.addons.length
    ? _c(
        "div",
        { staticClass: "d-flex justify-content-start flex-wrap" },
        _vm._l(_vm.sortedAddons, function (addonType, index) {
          return _c(
            "div",
            {
              key: "addon-badge-" + addonType + "-" + index,
              class: _vm.getAddonClass(addonType, index),
            },
            [
              _vm.isVivaincontri && addonType === "supertop"
                ? _c("span", [
                    _vm._v("\n      " + _vm._s(_vm.i18n.superhot) + "\n    "),
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.formatAddonTitle(addonType)))]),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }